<template lang="pug">
.message.elevation-5(
  v-if="isMessageShowing"
)
  .message__background
  v-container.relative
    .d-flex.flex-column.gap-12
      p.text-body-2
        | АИС "Управление мероприятиями" использует&nbsp;
        a.redesignPrimaryDarken--text.font-weight-medium(
          href="https://ru.wikipedia.org/wiki/Cookie"
          target="_blank"
        ) файлы cookie&nbsp;
        | Вашего браузера, чтобы гарантировать максимальное удобство использования, а также помогать получать
        | актуальную информацию. При использовании данного сайта, Вы подтверждаете свое согласие на использование
        | файлов cookie в соответствии с настоящим уведомлением в отношении данного типа файлов.
        | Если Вы не согласны с тем, чтобы мы использовали данный тип файлов, то Вы должны соответствующим
        | образом установить настройки вашего браузера или не использовать сайт.
      app-button(
        rounded
        @click="onSaveCookie"
      ).align-self-start Понятно
</template>

<script>
const LOCAL_STORAGE_KEY = 'is_cookie_message_disabled';

export default {
  name: 'CookieAgreement',
  components: {},
  props: {},
  data() {
    return {
      isMessageShowing: true,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.checkCookie();
  },
  methods: {
    checkCookie() {
      if (!navigator.cookieEnabled) {
        this.$toast.info('Файлы cookie заблокированы в настройках вашего браузера');
      }

      const isCookieMessageDisabled = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
      if (isCookieMessageDisabled) {
        this.isMessageShowing = false;
      }
    },
    onSaveCookie() {
      this.isMessageShowing = false;
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(true));
    },
  },
};
</script>

<style scoped lang="scss">
.message {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;

  &__background {
    position: absolute;
    inset: 0;
    background-color: #{$redesignPrimaryLighten};
    opacity: 0.9;
  }
}
</style>
